import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';

// styles
import ModalStyles from "../../../../Dashboard/DashboardReuseAbleComponents/Modal.module.css"

export default function FormSentModal(props) {
    const history = useHistory()
    return (
        <>
            <style type="text/css">
                {`
                .modal {
                    // background: #000000;
                }

                .modal-content {
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
            `}
            </style>

            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                keyboard={false}
                backdrop="static"
            >
                <Modal.Header dir='rtl'></Modal.Header>
                <Modal.Body dir='rtl'>
                    <div className='w-100 d-flex flex-column align-items-center justify-content-center py-2'>
                        <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                            <div className='my-3'>
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M27 0.1875C12.2157 0.1875 0.1875 12.2157 0.1875 27C0.1875 41.7843 12.2157 53.8125 27 53.8125C41.7843 53.8125 53.8125 41.7843 53.8125 27C53.8125 12.2157 41.7843 0.1875 27 0.1875ZM40.9541 18.0139L23.6291 38.6389C23.4391 38.8653 23.2026 39.0482 22.9357 39.1752C22.6688 39.3022 22.3777 39.3703 22.0822 39.375H22.0474C21.7583 39.3749 21.4725 39.314 21.2085 39.1963C20.9444 39.0786 20.7081 38.9067 20.5147 38.6918L13.0897 30.4418C12.9012 30.2418 12.7545 30.0061 12.6583 29.7486C12.5621 29.4911 12.5184 29.217 12.5296 28.9423C12.5409 28.6677 12.607 28.3981 12.7239 28.1493C12.8409 27.9005 13.0064 27.6777 13.2107 27.4938C13.4151 27.3099 13.6541 27.1688 13.9137 27.0786C14.1734 26.9884 14.4485 26.951 14.7228 26.9687C14.9971 26.9863 15.2651 27.0586 15.5111 27.1813C15.7571 27.304 15.976 27.4747 16.1551 27.6832L21.9933 34.1698L37.7959 15.3611C38.1504 14.9512 38.6519 14.6974 39.192 14.6543C39.7321 14.6113 40.2675 14.7825 40.6824 15.131C41.0973 15.4796 41.3584 15.9773 41.4092 16.5168C41.4601 17.0563 41.2966 17.5941 40.9541 18.0139Z" fill="#127442" />
                                </svg>
                            </div>
                            <div className={`my-2 ${ModalStyles.title}`}>
                                درخواست شما فرستاده شد نتیجه آن توسط پیامک به شما ارسال خواهد شد
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center align-items-center mb-3'>
                        <div className={`d-flex align-items-center justify-content-center ms-3 ${ModalStyles.filled_btn}`} onClick={() => history.push("/")} >
                            باشه
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
